import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import DaumPostCode from "react-daum-postcode";
import { useForm } from "react-hook-form";
import { root_url } from "../setting";

class Joiner {
  constructor(
    joinerName,
    cellphone,
    zipcode,
    zipAddress,
    address,
    amount,
    brief
  ) {
    this.joinerName = joinerName;
    this.exponent = null; //대표자
    this.cellphone = cellphone;
    this.zipcode = zipcode;
    this.zipAddress = zipAddress;
    this.address = address;
    this.paymentType = "BANK";
    this.paymentStatus = "RSVT"; //RSVD => RSVT
    this.brief = brief;
    this.amount = amount;
  }
}
class Runner {
  constructor(
    ticketSeq,
    souvenir = null,
    choiceOption = null,
    runnerName = null,
    birthday = null,
    gender = null,
    cellphone = null
  ) {
    this.ticketSeq = ticketSeq;
    this.souvenir = souvenir;
    this.choiceOption = choiceOption;
    this.runnerName = runnerName;
    this.birthday = birthday;
    this.gender = gender;
    this.cellphone = cellphone;
    this.backNo = null;
    this.chipNo = null;
  }
}
//form 입력할때마다 모든 Form이 rerendering되는데, 이를 막을 방법 -> react-hook-form
const ParticipantForm = ({ setNowProcess, setRes, ticketInfo }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const [ticketArray, setTicketArray] = useState([]);
  const [popupShow, setPopupShow] = useState(false);
  // const [name, setName] = useState('');
  // const [participantName, setParticipantName] = useState('');
  // const [phoneNum, setPhoneNum] = useState('');
  // const [participantPhoneNum, setParticipantPhoneNum] = useState('');
  const [isParticipantMan, setIsParticipantMan] = useState(true);
  const [participantCourse, setParticipantCourse] = useState(0); //ticketSeq -1과 일치하며, ticketArray가 아닌 ticketInfo의 인덱스와 일치한다!!
  const [giftList, setGiftList] = useState(null);
  const [participantGift, setParticipantGift] = useState("");
  const [participantGiftOption, setParticipantGiftOption] = useState("");
  const [itemList, setItemList] = useState([]); //2021 ver
  const [address, setAddress] = useState({
    zonecode: "",
    roadAddress: "",
    buildingName: "",
  });
  const [today, setToday] = useState(new Date());
  const [firstDisabled, setFirstDisabled] = useState(false);
  const [souvenirList, setSouvenirList] = useState([]);
  const [souvenirOptionList, setSouvenirOptionList] = useState([]);

  const [modal, setModal] = useState(false);
  const [flag, setFlag] = useState(false);
  const submitButton = useRef();
  useEffect(() => {
    // console.log(ticketInfo[participantCourse]);
    setSouvenirList([ticketInfo[participantCourse].souvenir]);
    setParticipantGift([ticketInfo[participantCourse].souvenir][0]);
    if (ticketInfo[participantCourse].choiceOption) {
      //기념품이 존재하는 경우, giftList를 가져오도록 한다.
      const new_gift_list =
        ticketInfo[participantCourse].choiceOption === undefined
          ? null
          : ticketInfo[participantCourse].choiceOption.split(",");
      setSouvenirOptionList(new_gift_list);
      setParticipantGiftOption(new_gift_list[0]);
    } else {
      setSouvenirOptionList(null);
    }
  }, [participantCourse, ticketInfo]);

  useEffect(() => {
    //처음에 ticketInfo를 display_order순으로 맞춰줘야함
    ticketInfo.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });
    // console.log(new_array);
    setTicketArray(ticketInfo);
  }, [ticketInfo]);

  useEffect(() => {
    console.log(ticketArray);
    if (ticketArray.length !== 0) {
      //ticket의 첫종목이 참가신청기간에 해당하는지에 대해 boolean
      const firstInDuration =
        new Date(ticketArray[0].saleOpenTime).getTime() <= today.getTime() &&
        today.getTime() <=
          (ticketArray[0].saleCloseTime == null
            ? new Date().getTime()
            : new Date(ticketArray[0].saleCloseTime).getTime());
      setFirstDisabled(
        ticketArray[0].acceptable <= ticketArray[0].total || !firstInDuration
      );
    }
  }, [ticketArray, today]);

  // const [birthday, setBirthday] = useState('');
  // console.log(ticketInfo);
  const onCompletePostCode = ({ zonecode, roadAddress, buildingName }) => {
    setPopupShow(false);
    setAddress({
      zonecode,
      roadAddress,
      buildingName,
    });
  };
  //participantCourse를 선택하였을 경우, 일어날 side-effect에 대하여...(gift를 보여주거나, itemList에 추가해준다.)
  useEffect(() => {
    // console.log(ticketInfo[participantCourse]);
    if (ticketInfo[participantCourse].choiceOption) {
      //기념품이 존재하는 경우, giftList를 가져오도록 한다.
      const new_gift_list =
        ticketInfo[participantCourse].choiceOption === undefined
          ? null
          : ticketInfo[participantCourse].choiceOption.split(",");
      setGiftList(new_gift_list);
      setParticipantGiftOption(new_gift_list[0]);
    } else {
      setGiftList(null);
      //여기서 아예 item_list에 추가할 수 있을 것이다.(트레킹의 경우만) 근데 중복 신청은 불가하다
      // for (let i in itemList) {
      //   //이미 해당 코스가 있다면 추가하지 않는다.
      //   if (itemList[i].course === participantCourse) {
      //     return;
      //   }
      // }
      // setItemList([...itemList, { course: participantCourse }]);
    }
  }, [participantCourse, itemList, ticketInfo]);

  //(individual)참가신청을 눌렀을때
  const onSubmit = (data) => {
    const {
      name,
      cellphone,
      detailAddress,
      participantName,
      birthday,
      participantCellphone,
    } = data;

    if (!flag) {
      setModal(true);
      setFlag(true);
      return;
    } else {
      //접수자 정보 초기화
      let brief;
      let amount = ticketInfo[participantCourse].ticketPrice;
      if (amount > 0) {
        //전화번호 네자리로 brief 설정
        brief = `${name}${cellphone.slice(
          cellphone.length - 4,
          cellphone.length
        )}`;
      } else {
        brief = "무료";
      }
      let addressInBuilding = address.roadAddress; //건물명 있을때는 추가해주기
      if (address.buildingName) {
        addressInBuilding += `(${address.buildingName})`;
      }
      const joiner = new Joiner(
        name,
        cellphone,
        address.zonecode,
        addressInBuilding,
        detailAddress,
        amount,
        brief
      );
      if (amount === 0) {
        joiner.paymentStatus = "CMPL"; //무료인 경우, 신청과 동시에 결제완료 처리가 되야한다.
      }
      //참가자 정보 초기화
      const runnerInfo = new Runner(
        ticketInfo[participantCourse].ticketSeq,
        participantGift, //souvenir
        participantGiftOption, //choiceOption
        participantName,
        birthday,
        isParticipantMan ? "M" : "F",
        participantCellphone
      );
      axios({
        method: "post",
        url: `${root_url}/api/applicant/applyFor`,
        // data: { joiner, runner: runnerInfo, runners: runners },
        data: { joiner, runners: [runnerInfo] },
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          console.log(res);
          const { data } = res;
          if (res.status === 200) {
            setRes(data);
            setNowProcess(3);
            // history.push({
            //   pathname: '/apply/payment',
            //   state: { data: data, ticketInfo: ticketInfo }, //만약 apply/payment에 url로 접속한다면 이를 막도록 해야함
            // });
          }
        })
        .catch((e) => {
          if (e?.response === undefined) {
            alert(
              "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
            );
          } else {
            console.log(e);
            if (e?.response?.data?.errorCode === "S0003") {
              // 해당 종목은 매진되었습니다.
              let alert_str = "";
              let full_ticket_set = new Set();
              const msgObj = JSON.parse(e.response.data.errorMessage);
              msgObj.data.map((runner) =>
                full_ticket_set.add(runner.ticketName)
              );
              full_ticket_set.forEach((el) => (alert_str += `${el},`));
              alert(`${alert_str} 해당 종목은 매진되었습니다.`);
            } else if (e?.response?.data?.errorCode === "S0004") {
              // 이미 신청 완료 되었습니다.
              let alert_str = "";
              const msgObj = JSON.parse(e.response.data.errorMessage);
              msgObj.data.map(
                (runner) => (alert_str += `${runner.runnerName},`)
              );
              alert(`${alert_str} 님은 이미 신청 완료 되었습니다.`);
            }
          }
          console.log(e?.response);
          //중복등으로 에러가 난 경우에는 status에 따라 적당히 유도를 해줘야한다.
          setNowProcess(2);
          //중복등으로 에러가 난 경우에는 status에 따라 적당히 유도를 해줘야한다.
        });
    }
  };
  const onSubmit_v1 = (data) => {
    console.log(">>> itemList.length : " + itemList.length);

    const {
      name,
      cellphone,
      detailAddress,
      participantName,
      birthday,
      participantCellphone,
    } = data;
    //1. address, participantCourse는 따로 state로 관리함
    //2. server에 참가자에 대한 정보 전송 -> ok return 된다면 다음단계로 넘어감
    let addressInBuilding = address.roadAddress; //건물명 있을때는 추가해주기
    if (address.buildingName) {
      addressInBuilding += `(${address.buildingName})`;
    }
    //종목선택하지 않았을 때,
    if (itemList.length === 0) {
      alert("종목을 선택해주세요");
      return;
    }
    let amount = 0;
    for (let i in itemList) {
      amount += ticketInfo[itemList[i].course].ticketPrice;
    }
    //결제 금액에 따라 `이름1234` or '무료' brief에 저장. 후에 카드결제 성공시에는 paymentKey로 변경
    let brief;
    if (amount > 0) {
      brief = `${name}${cellphone.slice(
        cellphone.length - 4,
        cellphone.length
      )}`;
    } else {
      brief = "무료";
    }
    const joiner = new Joiner(
      name,
      cellphone,
      address.zonecode,
      addressInBuilding,
      detailAddress,
      amount,
      brief
    );
    if (amount === 0) {
      joiner.paymentStatus = "CMPL"; //무료인 경우, 신청과 동시에 결제완료 처리가 되야한다.
    }

    const runnerInfo = new Runner(
      // ticketInfo[itemList[0].course].ticketSeq,
      null,
      null,
      null,
      participantName,
      birthday,
      isParticipantMan ? "M" : "F",
      participantCellphone
    );
    const runners = [];
    //ticketSeq만 담고있는 runners 객체 생성
    itemList.sort((a, b) => {
      //ticketSeq순서로 itemList 정렬
      return a.course - b.course;
    });
    for (let i in itemList) {
      console.log(itemList[i]);
      // let ticket = new Runner(ticketInfo[itemList[i].course].ticketSeq);
      if (itemList[i].gift !== undefined) {
        runners.push(
          new Runner(
            ticketInfo[itemList[i].course].ticketSeq,
            "티셔츠",
            itemList[i].gift
          )
        );
      } else {
        runners.push(new Runner(ticketInfo[itemList[i].course].ticketSeq));
      }
    }
    console.log(joiner);
    console.log(runnerInfo);
    console.log(runners);
    // for (let i in submitFormArray) {
    // const { joiner, runner } = submitFormArray[i];
    axios({
      method: "post",
      url: `${root_url}/api/applicant/apply`,
      data: { joiner, runner: runnerInfo, runners: runners },
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        console.log(res);
        const { data } = res;
        if (res.status === 200) {
          setRes(data);
          setNowProcess(3);
          // history.push({
          //   pathname: '/apply/payment',
          //   state: { data: data, ticketInfo: ticketInfo }, //만약 apply/payment에 url로 접속한다면 이를 막도록 해야함
          // });
        }
      })
      .catch((e) => {
        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.data.errorMessage);
        }
        console.log(e.response);

        //error message 보여줘야함!!!!
        if (
          typeof e.response.data !== undefined ||
          e.response.data.errorMessage !== undefined
        ) {
          alert(e.response.data.errorMessage);
        } else {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        }
        setNowProcess(2);
        //중복등으로 에러가 난 경우에는 status에 따라 적당히 유도를 해줘야한다.
      });
  };
  // };
  const onClickGift = (e) => {
    setParticipantGift(e.target.value);
  };
  const onClickGift_v1 = (e) => {
    //offline, online 마라톤의 기념품까지 고른 경우,
    setParticipantGift(e.target.value);
    //itemList에 추가해줘야함. 근데 이미 offline 마라톤 신청했다면 중복신청이 불가해야함!
    //여기 수정되어야함. participantCourse는 ticketSeq와 일치하기 때문에 범위로 될 수가 없음.
    //souvenir의 유무로 판단해야하나? 그럼 offline marathon, onlin marathon 중복 안되는데... 어떻게 해야하지?
    if (ticketInfo[participantCourse].ticketName.slice(0, 4) === "오프라인") {
      console.log("이미 오프라인 종목이 신청되어있는지 파악해야함.");
      for (let i in itemList) {
        //itemList.course <= participantCourse의 리스트가 저장됨
        //기존 선택한 것들 중에 offline 종목이 있나 확인하면 됨
        if (
          ticketInfo[itemList[i].course].ticketName.slice(0, 4) === "오프라인"
        ) {
          alert("오프라인 마라톤은 중복신청이 불가합니다.");
          return;
        }
      }
    } else {
      //online 마라톤이 이미 있다면 추가하지 않는다.
      for (let i in itemList) {
        if (itemList[i].course === participantCourse) {
          return;
        }
      }
      console.log(itemList);
    }
    const newItemList = [
      ...itemList,
      { course: participantCourse, gift: e.target.value },
    ];
    setItemList(newItemList);
  };
  const onDeleteItem = (index) => {
    setItemList(itemList.filter((item) => item !== itemList[index]));
  };
  return (
    <div>
      <Modal show={modal} onHide={() => setModal(false)} size="lg" centered>
        <Modal.Header
          closeButton
          onClick={() => {
            setFlag(false);
          }}
        ></Modal.Header>
        <Modal.Body>
          개인 {ticketInfo[participantCourse].ticketName} 신청합니다.
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModal(false);
              setFlag(true);
              submitButton.current.click();
            }}
          >
            확인했습니다
          </Button>
        </Modal.Footer>
      </Modal>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container className="row m-0">
          <div className="col-xs-10 col-md-6 mt-3">
            <Row className="text-md-center text-start text-custom-color mb-5">
              <h3>접수자 정보</h3>
            </Row>
            <Form.Group controlId="name" className="mb-5">
              <Form.Label className="fw-bold">이름</Form.Label>
              <input
                type="text"
                className="form-in-class"
                placeholder="홍길동"
                {...register("name", {
                  required: true,
                  maxLength: 50,
                  pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
                })}
              />
              {errors.name && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
                </span>
              )}
            </Form.Group>
            <Form.Group controlId="phone" className="mb-5">
              <Form.Label className="fw-bold">
                핸드폰번호(-제외 11자 이내)
              </Form.Label>
              <input
                type="number"
                className="form-in-class"
                placeholder="01012345678"
                {...register("cellphone", {
                  required: true,
                  maxLength: 11,
                  pattern: /^01[016789]\d{3,4}\d{4}$/, // 핸드폰 번호
                  // pattern:
                  // /^0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|7[0-6]|8[1-9]|9[0-4]|1[0-9][1-9])\d{0,1}\d{3,4}\d{4}$/, // 일반 전화
                })}
              />
              {errors.cellphone && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)전화번호는 4자 이상, 전화번호는 11자 이하의 숫자만
                  입력해주세요.
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-5">
              <Form.Label className="fw-bold">주소</Form.Label>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="우편번호"
                    value={address.zonecode}
                    onClick={() => setPopupShow(!popupShow)}
                    onChange={() => console.log("")}
                  />
                </Col>
                <Col>
                  <Button
                    className="border bg-custom-color mb-4"
                    onClick={() => setPopupShow(!popupShow)}
                  >
                    우편번호 찾기
                  </Button>
                </Col>
              </Row>

              <Form.Control
                type="text"
                placeholder="주소"
                onClick={() => setPopupShow(!popupShow)}
                value={
                  address.roadAddress &&
                  `${address.roadAddress}(${address.buildingName})`
                }
                onChange={() => {
                  console.log("");
                }}
                className="mb-4"
              />
              <input
                type="text"
                className="form-in-class"
                placeholder="상세주소"
                {...register("detailAddress", {
                  required: true,
                })}
              />
              {errors.detailAddress && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)상세주소를 입력해주세요.
                </span>
              )}
            </Form.Group>
            <Modal
              show={popupShow}
              onHide={() => setPopupShow(false)}
              size="lg"
              centered
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <DaumPostCode onComplete={onCompletePostCode} />
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-xs-10 col-md-6 mt-3">
            <Row className="text-md-center text-start text-custom-color">
              <h3>참가자 정보</h3>
            </Row>
            <Form.Group controlId="formCheckbox" className="mb-4">
              <Button
                // onClick={onClickCheck}
                className="bg-custom-color"
                style={{ boxShadow: "none" }}
                onClick={() => {
                  setValue("participantName", watch("name"));
                  setValue("participantCellphone", watch("cellphone"));
                }}
              >
                접수자와 동일
              </Button>
            </Form.Group>
            <Form.Group className="mb-5">
              <Form.Label className="fw-bold">이름</Form.Label>
              <input
                type="text"
                className="form-in-class"
                placeholder="홍길동"
                {...register("participantName", {
                  required: true,
                  maxLength: 50,
                  pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
                })}
              />
              {errors.participantName && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-5">
              <Form.Label className="fw-bold">생년월일 (8자리)</Form.Label>
              <input
                type="number"
                className="form-in-class"
                placeholder="19990320"
                {...register("birthday", {
                  required: true,
                  maxLength: 8,
                  pattern: /^[0-9]{8,8}/g,
                })}
              />
              {errors.birthday && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)1999/03/20 : 19990320 8자리로 입력해주세요.
                </span>
              )}
            </Form.Group>
            <div className="mb-5">
              <p className="fw-bold">성별</p>
              <Row className="text-center">
                <div
                  className={`${
                    isParticipantMan
                      ? "bg-custom-color text-white"
                      : "bg-custom-grey"
                  } col-4 offset-2 rounded-pill cursor-pointer`}
                  onClick={() => setIsParticipantMan(true)}
                  style={{ height: "2rem", lineHeight: "2rem" }}
                >
                  남자
                </div>
                <div
                  className={`${
                    !isParticipantMan
                      ? "bg-custom-color text-white"
                      : "bg-custom-grey"
                  } col-4 offset-1 rounded-pill cursor-pointer`}
                  onClick={() => setIsParticipantMan(false)}
                  style={{ height: "2rem", lineHeight: "2rem" }}
                >
                  여자
                </div>
              </Row>
            </div>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold mt-2">
                핸드폰번호(-제외 11자 이내)
              </Form.Label>
              <input
                type="number"
                className="form-in-class"
                placeholder="01012345678"
                {...register("participantCellphone", {
                  required: true,
                  maxLength: 11,
                  pattern: /^01[016789]\d{3,4}\d{4}$/,
                })}
              />
              {errors.participantCellphone && (
                <span
                  className="position-absolute"
                  style={{ fontSize: "0.8rem", color: "red" }}
                >
                  (필수)전화번호는 4자 이상, 11자 이하의 숫자만 입력해주세요.
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">종목 선택</Form.Label>
              {/* 신청가능한 날인지, 품절되진 않았는지 */}
              <select
                value={participantCourse}
                onChange={(e) => {
                  console.log("participantCourse : " + e.target.value);
                  setParticipantCourse(e.target.value);
                  setParticipantGift("0");
                  setFlag(false);
                }}
                className="custom-select"
              >
                {/* ticket이 일부 품절일 경우는 어떻게 되는지 꼭 확인하도록 하자! */}
                {/* 시간이 null인 경우에 어떻게 처리해야 하는지!! */}
                {ticketArray.map((ticket, key) => {
                  const inDuration =
                    new Date(ticket.saleOpenTime).getTime() <=
                      today.getTime() &&
                    today.getTime() <=
                      (ticket.saleCloseTime == null
                        ? new Date().getTime()
                        : new Date(ticket.saleCloseTime).getTime());
                  return (
                    <option
                      value={ticket.ticketSeq - 1}
                      key={ticket.ticketSeq}
                      disabled={
                        ticket.acceptable <= ticket.total || !inDuration
                      }
                    >
                      {/* {ticket.ticketName}|{ticket.ticketSeq - 1} */}
                      {ticket.ticketName}
                    </option>
                  );
                })}
              </select>
            </Form.Group>
            {/* 여기 복구해야함!! */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">기념품 선택</Form.Label>
              <select
                value={participantGift}
                onChange={(e) => setParticipantGift(e.target.value)}
                className="custom-select"
              >
                {souvenirList.map((souv, key) => (
                  <option key={souv}>{souv}</option>
                ))}
              </select>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">기념품 옵션 선택</Form.Label>
              <select
                value={participantGiftOption}
                onChange={(e) => setParticipantGiftOption(e.target.value)}
                className="custom-select"
              >
                {souvenirOptionList.map((souv, key) => (
                  <option key={souv}>{souv}</option>
                ))}
              </select>
            </Form.Group>

            {/* 2021 ver */}
            {itemList.length !== 0 && (
              <div>
                <p className="fw-bold">신청 종목</p>
                {itemList.map((item, key) => {
                  return (
                    <Row key={key}>
                      <Col xs={8}>
                        {ticketInfo[item.course].ticketName}
                        {item.gift !== undefined && " / "}
                        {item.gift}
                      </Col>
                      <Col
                        onClick={() => onDeleteItem(key)}
                        className="cursor-pointer"
                        xs={{ offset: 2, span: 1 }}
                      >
                        <i className="far fa-times-circle"></i>
                      </Col>
                      <hr className="m-1 ms-2" />
                    </Row>
                  );
                })}
              </div>
            )}
            <input
              ref={submitButton}
              type="submit"
              className="bg-custom-color p-2 ps-3 pe-3 rounded text-white mb-5"
              style={{ border: "none" }}
              value="접수하기"
            />
          </div>
        </Container>
      </form>
    </div>
  );
};
export default ParticipantForm;
